<template>
    <div class="card">
        <div class="card-header">
            <h5 class="card-title">Items</h5>
        </div>
        <div class="card-body">
            <order-item v-for="item in orderItems" :key="item.id" :item="item"></order-item>
        </div>
    </div>
</template>
<script>
import { firebaseObjectToArray } from '@/utils'
import OrderItem from './OrderItem'
export default {
    components: {
        OrderItem
    },
    props: {
        orderItems: {
            type: Array,
            required: true
        }
    },
    methods: {
        firebaseObjectToArray
    }
}
</script>
